import type { TransportRouteRecord } from '../../services/transportRouteApi';

/** A route's configured monthly fare, formatted for display. The API sends it
 *  as a decimal string; routes with no fare set render as an em dash. */
export function routeMonthlyFeeLabel(route: TransportRouteRecord | undefined): string {
    const raw = route?.default_monthly_fee;
    if (raw === null || raw === undefined || raw === '') return '—';
    const fee = typeof raw === 'number' ? raw : parseFloat(raw);
    if (!Number.isFinite(fee)) return '—';
    const paise = Number.isInteger(fee) ? 0 : 2;
    return `₹${fee.toLocaleString('en-IN', { minimumFractionDigits: paise, maximumFractionDigits: 2 })}`;
}
